import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function Forgot() {
  return (
    <StyledForgot className="main">
      <div className="container">
        <div className="auth">
          <div className="auth_form_wrapper row justify-content-center">
            <div className="col-sm-8 col-md-7 col-lg-6">
              <div className="auth_fargot">
                <form action="" className="auth_form">
                  <h1 className="h3 mb-4 text-center">Забыли пароль</h1>
                  <div className="auth_form_group form-floating mb-3">
                    <input type="text" className="form-control" />
                    <label for="">Email</label>
                  </div>
                  <button
                    className="btn-lg btn btn-primary w-100"
                    type="submit"
                  >
                    Восстановить
                  </button>
                  <div className="form_fargot text-center mt-3">
                    Пытаетесь войти?{" "}
                    <Link to="/auth/login" className="blue_link">
                      Войти
                    </Link>
                  </div>
                </form>
                <div className="auth_fargot_footer text-center p-3 p-md-4">
                  Нет аккаунта?
                  <Link to="/auth/register" className="ms-1 blue_link">
                    Регистрация
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledForgot>
  );
}

const StyledForgot = styled.main`
  .auth_form {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
    padding: 2.5rem;
  }

  .auth_fargot {
    background-color: #fff;
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%);
    border: 1px solid rgba(0, 0, 0, 0.125);
  }
  .auth_fargot_footer {
    background-color: rgba(0, 0, 0, 0.03);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }
`;
